module.exports = __webpack_public_path__ + "img/pc_wl.a95d2851.png";